export enum ComparisonMonth {
    LAST_MONTH = 'LAST_MONTH',
    THIS_MONTH_LAST_YEAR = 'THIS_MONTH_LAST_YEAR'
}
